import React from "react";

export default function ColorFrame27({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#F9D6B2"
          d="M247.764 153.59l-11.483 3.845c-.051-10.65-1.422-17.906-2.492-27.486-.683-5.948.442-3.586 2.492-14.485 1.237-6.573-53.556 83.376-18.633-17.868 7.465-18.582 16.141-44.096 10.252-50.375-15.258-16.27-27.778 26.669-51.583 42.612-34.742 23.268-74.971 40.116-74.971 40.116-.256.045-6.26-15.571-6.901-16.852-3.191-6.844-4.98-5.921-9.785-11.778-5.561-6.707-20.921-12.103-29.13-8.727-8.673 3.567-6.636 11.214 0 20.505 9.612 13.456 11.912 19.348 11.912 31.488 0 9.291-2.941 16.695-2.941 32.073 0 15.379 8.971 37.486 8.971 37.486l-33.641 72.483h107.651l2.884-14.492s29.796-15.862 47.738-34.282c17.942-18.42 10.252-18.262 22.107-23.709 2.479-2.428 13.552-9.153 18.903-18.903 5.35-9.75 8.708-29.636 8.65-41.651z"
        ></path>
        <path
          fill="#A556CB"
          d="M154.851 280.465L45.598 257.076l-9.932 29.476 119.185 1.922v-8.009z"
        ></path>
        <path
          fill="#444B8C"
          d="M203.527 9.526L88.324 21.036a5.291 5.291 0 00-4.74 5.792l22.568 225.858a5.29 5.29 0 005.791 4.739l115.203-11.511a5.29 5.29 0 004.739-5.791L209.318 14.265a5.291 5.291 0 00-5.791-4.739z"
        ></path>
        <path
          fill="#fff"
          d="M222.53 235.732a5.225 5.225 0 01-1.734 2.183 5.347 5.347 0 01-2.625 1.002l-49.674 4.904-49.756 4.87a5.355 5.355 0 01-3.877-1.15 5.175 5.175 0 01-1.913-3.509L92.397 40.742a5.15 5.15 0 011.174-3.813 5.329 5.329 0 013.57-1.884l46.215-4.564 53.209-5.234a5.382 5.382 0 012.057.194 5.316 5.316 0 011.824.954 5.2 5.2 0 011.313 1.568c.329.602.534 1.263.603 1.943l20.554 203.314a5.115 5.115 0 01-.386 2.512z"
        ></path>
        <path
          fill="#F9D6B2"
          d="M209.558 118.303c-2.771-6.665 5.349-15.542 9.756-19.148 5.258-3.448 16.787-8.796 20.836-2.599 5.062 7.746 3.632 17.353-8.276 23.87-11.907 6.517-18.852 6.209-22.316-2.123z"
        ></path>
        <path
          fill="#F9D6B2"
          d="M212.423 141.53c-2.82-7.021 5.056-16.209 9.346-19.925 5.132-3.541 16.414-8.984 20.487-2.437 5.091 8.183 3.814 18.228-7.824 24.892-11.638 6.663-18.483 6.246-22.009-2.53z"
        ></path>
        <path
          fill="#F9D6B2"
          d="M218.143 165.976c-2.729-6.813 4.857-15.717 8.992-19.317 4.947-3.428 14.138-10.609 19.76-2.34 5.255 7.728 3.701 17.686-7.518 24.136-11.219 6.45-17.823 6.037-21.234-2.479z"
        ></path>
        <circle
          cx="146.836"
          cy="22.659"
          r="2.795"
          fill="#E2A5FF"
          transform="rotate(-1.686 146.836 22.66)"
        ></circle>
        {children}
      </g>
    </svg>
  );
}
